export default {
  path: 'brands',
  component: () => import('@/views/business/inventory/brands/index.vue'),
  children: [
    {
      path: ':brandId/details',
      name: 'inventory.brands.details',
      component: () => import('@/views/business/inventory/brands/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: 'create',
      name: 'inventory.brands.create',
      component: () => import('@/views/business/inventory/brands/details.vue'),
      meta: {
        hideTabs: true,
      },
    },
    {
      path: '',
      name: 'inventory.brands.list',
      component: () => import('@/views/business/inventory/brands/list.vue'),
    },
  ],
}
